var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cfd-list"},[_vm._l((_vm.columnsToShow),function(column){return [(!_vm.hasSubcolumns(column))?_c('InstrumentsListItemDataItem',{key:column.MatchingFieldName,attrs:{"instrument":_vm.instrument,"column":column}}):_vm._l((column.SubColumns),function(subcolumn){return _c('InstrumentsListItemDataItem',{key:subcolumn.MatchingFieldName,attrs:{"instrument":_vm.instrument,"column":subcolumn}})})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75e1363f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/InstrumentsListItemData.vue
// module id = 137
// module chunks = 0